export enum MILLISECOND {
  SECOND_10 = 10 * 1000,
  SECOND_30 = 30 * 1000
}
